import React, { useState, useEffect } from 'react'; 
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import logo from "../../../images/TestAssessify.png";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { greetTime } from '../../account/login';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { api } from '../../../api/jointExam';
import { exams } from '../../../api/exams';
import Loader from '../../../components/loader/Loader';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { clearFlaggedQuestion } from '../../../features/candidate-exam/candidate-exam-slice';
import LanguageSwitcher from '../../../components/LanguageSwitcher';

type viewType = 'rejoin' | 'join' | null
export const primary_colour = '#88a848'

const ResultView = () => {
  const { t } = useTranslation();
  const [defaultEmail, setDefaultEmail] = useState<string>('')

  const { data: userData, isLoading } = useQuery(
    ["User Data"],
    async () => {
      const data = await exams.getBranding();
      return data;
    },
    {
      select: (response) => response?.data,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      onError: (error: any) => {
        if (
          error?.response?.data?.message === 'Exam does not exist'
          && error?.response?.status === 400
        ) {
          navigate('/page-not-found')
        }
      },
      onSuccess: (data) => {
        if(data){
          sessionStorage.setItem("client", JSON.stringify(data));
        }
      }
    },
  );

  const { mutateAsync, isLoading: isSubmitting } = useMutation(api.loginToExamLaunch)
  const { mutateAsync: checkEmail, isLoading: isSubmittingCheckEmail } = useMutation(api.checkExamResult)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const successAction = (response: any): void => {
    toast.success(t('candidate-verified'));
    sessionStorage.setItem("userToken", response.data.token);
    sessionStorage.setItem('user_id', response?.data?.user?.user_id)
    dispatch(clearFlaggedQuestion(null));
    sessionStorage.setItem("user", JSON.stringify(response?.data?.user));
    sessionStorage.setItem("loginType", 'join');
    sessionStorage.setItem("joinType", 'result');
    navigate('/candidate/exam-history');
  }

  const rejoinExam = async (): Promise<any> => {
    //  const domain = defaultEmail.split('@')[1]?.toLowerCase();
    //   if (!defaultEmail) {
    //     return toast.error(t('email-required'));
    //   }
    //   else if (allowedDomains?.length && (!domain || !allowedDomains.includes(domain))) {
    //     toast.error(emailDomainErrorMessage);
    //     return;
    //   }
    try {
      const response = await checkEmail({
        email: defaultEmail,
      });
      successAction(response)
    }
    catch (error: any) {
      toast.remove();
      if (error?.response?.status === 400 || error?.response?.status === 500) {
        return toast.error(error?.response?.data?.message)
      }
      toast.error(t('reload-error'));
    }
  }

  if (isLoading) return <Loader />;

  return (
    <>
      <div className="bg-white p-4 lg:p-6">
        <div className="w-full flex items-center justify-between pb-4 h-26 bg-inherit sticky top-0 cursor-pointer">
          <div className="h-full">
            <Link to={'/'}>
              <img
                src={ userData?.image_url || logo}
                alt="Test Assessify"
                className={ userData?.image_url ? '' : "w-64 h-[60px]"}
              />
            </Link>
          </div>
          <LanguageSwitcher className='border border-slate-300 mr-5 py-3 px-3 rounded-xl focus:border-slate-300 focus:outline-none' containerClassName='flex items-center justify-center' />
        </div>
        <div className="flex justify-center items-center 2xl:mt-0 2xl:h-screen">
          <div className="bg-cover bg-no-repeat bg-hero-img w-full md:w-[600px] lg:w-[900px] 2xl:w-[1440px] 2xl:h-[800px] rounded-xl p-2 lg:p-10 sm:shadow-2xl">
            <div className="my-2 shadow-2xl rounded-[8px] bg-white w-full lg:w-2/3 2xl:h-[700px] 2xl:mt-5 p-4 2xl:p-6">
              <div className="flex flex-col w-full">
                <div className="flex flex-col justify-center lg:px-4 pt-8 my-auto md:justify-start md:pt-0 2xl:px-10">
                  <div className='py-12 pt-3'>
                    <div className="2xl:mb-3">
                      <div className="flex md:items-center justify-start w-full overflow-hidden">
                        <h1 className="text-3xl capitalize md:w-3/4 object-contain font-medium text-darkBlue">
                          Good {greetTime()}
                        </h1>
                      </div>
                      <p className="my-2 text-md text-slate-500">
                         Please enter your email address to view result.
                      </p>
                    </div>
                  </div>
                  { (
                    <div className='py-5'>
                      <fieldset className="border border-gray-200 -mt-5 p-4 rounded-xl shadow">
                        <legend className="px-4 text-lg font-semibold text-gray-700 bg-white rounded-md border border-gray-300">
                          {/* {t('work-email')} */} Email Address
                        </legend>
                        <div className="relative flex w-full focus:outline-none focus:ring-2 focus:ring-[#88a848] focus:border-transparent">
                          <input
                            type="email"
                            value={defaultEmail}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                              setDefaultEmail(event.target.value);
                            }}
                            className="flex-1 appearance-none border rounded-xl border-gray-300 w-full py-4 px-4 2xl:py-8 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none"
                            placeholder='e.g user@gmail.com'
                          />
                        </div>
                        <div className='flex justify-end mt-4'>
                          <button
                            type="button"
                            onClick={rejoinExam}
                            style={{ backgroundColor: userData?.primary_colour || '#88a848' }}
                            className="mt-3 px-12 2xl:py-4 py-2 rounded-lg text-sm text-center text-white transition duration-200 ease-in bg-[#88a848] shadow-md focus:outline-none focus:ring-2"
                          >
                            {isSubmittingCheckEmail ? t('submitting') : <span className="w-full text-lg">{t('start-exam')}</span>}
                          </button>
                        </div>
                      </fieldset>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResultView;